// extracted by mini-css-extract-plugin
export default {"service_card":"KeyServiceCard_service_card__Wwsky","service_icon":"KeyServiceCard_service_icon__L1AtD","service_btn":"KeyServiceCard_service_btn__DGYek"};